import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetPlaybooksQuery } from '../../services/api';
import { setSubscribedPlaybooks, setSubscribedPlaybooksLoaded } from '../../redux/slices/appSlice';
import { PlaybookType } from '../../constants/agents/playbooks';

const supportedPlaybookTypes = new Set(Object.values(PlaybookType).map(playbook => playbook.value));

const normalizePlaybook = playbook => {
  if (!playbook || !supportedPlaybookTypes.has(playbook.playbookType)) return null;

  return {
    id: playbook.id,
    title: playbook.title,
    value: playbook.playbookType,
    playbookType: playbook.playbookType,
    agentTypes: Array.isArray(playbook.agentTypes) ? playbook.agentTypes : [],
    isDefault: Boolean(playbook.isDefault),
  };
};

const usePlaybookHandler = () => {
  const playbooks = useSelector(state => state.app.subscribedPlaybooks);
  const dispatch = useDispatch();

  const { data: playbooksData, isError } = useGetPlaybooksQuery(undefined, {
    skip: window.location.pathname.includes('/login'),
  });

  useEffect(() => {
    if (playbooksData?.success && Array.isArray(playbooksData.data)) {
      const normalizedPlaybooks = playbooksData.data.map(normalizePlaybook).filter(Boolean);

      dispatch(setSubscribedPlaybooks(normalizedPlaybooks));
    } else if (isError || playbooksData) {
      // A failed or unexpected response still settles loading; screens fall back to defaults.
      dispatch(setSubscribedPlaybooksLoaded(true));
    }
  }, [playbooksData, isError, dispatch]);

  return playbooks;
};

export default usePlaybookHandler;
